import { BodyText, Heading, Icon, IconSet } from '@postscript/components';
import styled from 'styled-components';
import * as styles from '../styles';

const ZeroStateText = styled.div`
  max-width: 1008px;

  h2 {
    padding-bottom: var(--spacing-1);
  }
`;

const NoConversations = (): JSX.Element => (
  <styles.ZeroState>
    <ZeroStateText>
      <Heading as="h2" size="small">
        Data & Insights Coming Soon
      </Heading>
      <BodyText size="small">
        Conversations analytics, summaries, and insights will become available
        once conversations start getting resolved.
      </BodyText>
    </ZeroStateText>
    <styles.ZeroStateCards>
      <styles.ZeroStateCard>
        <Icon
          color="var(--color-topic-primary)"
          component={IconSet.TwoWayConvo}
          size={48}
        />
        <Heading size="x-small">Review conversations</Heading>
        <BodyText size="small">
          Analyze interactions to uncover trends and refine your messaging.
        </BodyText>
      </styles.ZeroStateCard>
      <styles.ZeroStateCard>
        <Icon
          color="var(--color-topic-primary)"
          component={IconSet.PostscriptAi}
          size={48}
        />
        <Heading size="x-small">Get insights</Heading>
        <BodyText size="small">
          Unlock AI-powered insights to improve sales and personalize offers.
        </BodyText>
      </styles.ZeroStateCard>
      <styles.ZeroStateCard>
        <Icon
          color="var(--color-topic-primary)"
          component={IconSet.Users}
          size={48}
        />
        <Heading size="x-small">Build better segments</Heading>
        <BodyText size="small">
          Leverage data to understand customers and improve targeting.
        </BodyText>
      </styles.ZeroStateCard>
    </styles.ZeroStateCards>
  </styles.ZeroState>
);

export default NoConversations;
